import { Colors } from './colors';
export const Card = {
  // The styles all Cards have in common
  baseStyle: {
    background: 'white',
    alignItems: 'center',
    gap: 6,
  },
  // Two variants: rounded and smooth
  variants: {
    login: {
      background: '#FFFFFF',
      border: 'none',
      borderRadius: '10px',
      boxShadow: 'md',
    },
    main: {
      background: '#FFFFFF',
      border: '0.15rem solid' + Colors.borderMain,
      borderRadius: 'base',
      boxShadow: 'md',
    },
    mainFixed: {
      background: '#FFFFFF',
      border: '0.15rem solid' + Colors.borderMain,
      borderRadius: 'base',
      boxShadow: 'md',
      position: 'fixed',
    },
    content: {
      background: '#FFFFFF',
      margin: 5,
    },
    stack: {
      marginTop: 5,
      marginBottom: 5,
    },
    filter: {
      background: '#FFFFFF',
      paddingTop: 5,
      margin: '20px !important',
    },
    filterEnd: {
      background: '#FFFFFF',
      margin: 5,
      paddingTop: 5,
      paddingBottom: 5,
      borderBottom: '0.15rem solid' + Colors.borderMain,
    },
    rounded: {
      padding: 8,
      borderRadius: 'xl',
      boxShadow: 'xl',
    },
    smooth: {
      padding: 3,
      borderRadius: 'base',
      boxShadow: 'md',
      margin: '10px 0px',
    },
  },
  // The default variant value
  defaultProps: {
    variant: 'smooth',
  },
};
